export default __webpack_public_path__ + "static/media/medical_functionality_img.be865c62.png";